import React from 'react';

export const WarningIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`shrink-0 ${className}`}
  >
    <path
      d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6.5 9H5.5V8H6.5V9ZM6.5 7H5.5V3H6.5V7Z"
      fill="currentColor"
    />
  </svg>
);
